"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Webhooks = exports.Users = exports.Uploads = exports.Terms = exports.Tags = exports.Sso = exports.Rooms = exports.LoginIdentities = exports.Licenses = exports.Images = exports.Groups = exports.Downloads = exports.Devices = exports.Default = exports.Countries = exports.Companies = exports.CentralLogin = exports.AuthLogin = exports.Auth = exports.Apps = exports.Analytics = void 0;
exports.Analytics = __importStar(require("./AnalyticsApi"));
exports.Apps = __importStar(require("./AppsApi"));
exports.Auth = __importStar(require("./AuthApi"));
exports.AuthLogin = __importStar(require("./AuthLoginApi"));
exports.CentralLogin = __importStar(require("./CentralLoginApi"));
exports.Companies = __importStar(require("./CompaniesApi"));
exports.Countries = __importStar(require("./CountriesApi"));
exports.Default = __importStar(require("./DefaultApi"));
exports.Devices = __importStar(require("./DevicesApi"));
exports.Downloads = __importStar(require("./DownloadsApi"));
exports.Groups = __importStar(require("./GroupsApi"));
exports.Images = __importStar(require("./ImagesApi"));
exports.Licenses = __importStar(require("./LicensesApi"));
exports.LoginIdentities = __importStar(require("./LoginIdentitiesApi"));
exports.Rooms = __importStar(require("./RoomsApi"));
exports.Sso = __importStar(require("./SsoApi"));
exports.Tags = __importStar(require("./TagsApi"));
exports.Terms = __importStar(require("./TermsApi"));
exports.Uploads = __importStar(require("./UploadsApi"));
exports.Users = __importStar(require("./UsersApi"));
exports.Webhooks = __importStar(require("./WebhooksApi"));
//# sourceMappingURL=index.js.map